import { isStandalone } from "../pwa/platform";
import { signedInUserId } from "../components/chatbot/testShell/answerOutbox";

// "Shared computer" sign-out (F19). The student ticks it at sign-in (LoginModal); while it's
// on, SharedComputerGuard (common/StillThereCard.js) asks "Still there?" after 10 quiet
// minutes and signs out a minute later. The choice lasts for this sign-in only:
// clearSession() forgets it (utils/studentTraces.js).

export const SHARED_KEY = "anna.sharedComputer";
// The last time anyone used Anna in this browser, so a busy tab keeps a quiet one signed in
export const ACTIVE_KEY = "anna.lastActive";
export const IDLE_MS = 10 * 60 * 1000;
export const COUNTDOWN_S = 60;

const safe = (fn, fallback) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

const media = (query) =>
  safe(() => Boolean(window.matchMedia && window.matchMedia(query).matches), false);

/** On by default on a computer (mouse, wide screen); off on phones and tablets. */
export const defaultSharedComputer = () => {
  if (isStandalone()) return false;
  const mouse = media("(hover: hover) and (pointer: fine)");
  const wide = safe(() => window.innerWidth >= 900, false);
  return mouse && wide;
};

/** The tick box is hidden in the installed app: that phone belongs to the student. */
export const offerSharedComputer = () => !isStandalone();

export const setSharedComputer = (on) =>
  safe(() => {
    if (on) localStorage.setItem(SHARED_KEY, "1");
    else localStorage.removeItem(SHARED_KEY);
  });

export const isSharedComputer = () =>
  safe(() => localStorage.getItem(SHARED_KEY) === "1" && Boolean(localStorage.getItem("authToken")), false);

// ---- Test chat in progress --------------------------------------------------------
// Chatbot.js sets this from TestChat's onActiveChange (a question on screen or saving).
let testChatBusy = false;
export const setTestChatBusy = (busy) => {
  testChatBusy = Boolean(busy);
};

const WAITING_PREFIX = "anna:waitingAnswers:"; // testShell/answerOutbox.js

// Only the signed-in student's: answers another student left after an automatic sign-out
// (they're kept, F21) must not keep this one signed in forever
const answersWaiting = () =>
  safe(() => {
    const owner = signedInUserId();
    const mine = owner ? `${WAITING_PREFIX}${owner}:` : WAITING_PREFIX;
    for (let i = 0; i < localStorage.length; i += 1) {
      if (String(localStorage.key(i) || "").startsWith(mine)) return true;
    }
    return false;
  }, false);

/** True while a test chat is open or answers are still being saved: never sign out then. */
export const isTestChatBusy = () =>
  testChatBusy ||
  answersWaiting() ||
  safe(() => Boolean(document.querySelector(".ts-view")), false);
